import {
  apiGetRequest,
  apiPostRequest,
  cdnGetRequest,
} from "../utils/webrequests";
import { UserProfile } from "../data/userProfile";
import { UserInfo } from "../data/userInfo";

export async function getUser(CurrentId: string): Promise<UserProfile> {
  const data: UserProfile = await apiGetRequest("GetUser?id=" + CurrentId, null);
  return data;
}

export async function saveUser(SaveUser: string): Promise<any> {
  const data: UserProfile = await apiPostRequest("UpdateUser", SaveUser);
  return data;
}

export async function getUsers(): Promise<UserInfo[]> {
  try {
    const data: UserInfo[] | undefined = await apiGetRequest("GetUsers", null);
    if (!data) {
      throw new Error("No data received from API");
    }
    return data;
  } catch (error: any) {
    throw new Error("Error fetching event info: " + error.message);
  }
}
